import React, { FC, useEffect, useState } from 'react';
import { Col, Container, Nav, Row, Tab } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { MagnifyingGlass } from 'src/assets/images/Svgs/svg';
import Loader from 'src/components/Loader/Loader';
import ItemSearch from 'src/components/TabContainer/ItemSearch/ItemSearch';
import NavItems from 'src/components/TabContainer/NavItems/NavItems';
import AccountStatusModal from 'src/containers/account/AccountStatusModal';
import NavItemContent from 'src/containers/Manu.tsx/ManuContainer';
import useVerifyAccount from 'src/hooks/useVerifyAccount';
import { ItemDetails } from 'src/models/item.model';
import { IAccountStatus } from 'src/models/misc';
import useCategories from 'src/react-query-hooks/useCategories';
import { useAppDispatch, useAppSelector } from 'src/redux/store/store';

import * as CONSTANT from '../../constants';

import styles from './menu.module.scss';
import useCheckMobileScreen from 'src/hooks/useCheckMobileScreen';
import { handleIsLiveLocationRedirection } from 'src/helper/checkout/LocationHelper';
import { setLocation } from '../Location/redux/slice';
import {
  updateIsOrderTypeSelected,
  updateOrderDetails,
  updateOrderType,
} from 'src/redux/slices/cartSlice';
interface RouteParams {
  selected_category?: string;
}
const Menu: FC<any> = () => {
  const isLiveOrderBarShow = document.getElementById('live-order-bar');
  const [categoryScrolled, setCategoryScrolled] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const [SearchShow, setSearchShow] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const isItMobile = useCheckMobileScreen();

  const dispatch = useAppDispatch();

  const locationId = useAppSelector(
    (state) => state.location.selectedStore?.id,
  );
  const { user } = useAppSelector((state) => state.user);
  const [items, setItems] = useState<ItemDetails[]>([]);
  const [isSearching, setIsSearching] = useState<boolean>(false);

  const { selected_category } = useParams<RouteParams>();
  const [key, setKey] = useState<string>('');
  const [categoryMenuVisbility, setCategoryMenuVisbility] =
    React.useState<boolean>(true);
  const history = useHistory();
  const {
    data: menus = [],
    isFetching,
    refetch: refetchMenu,
  } = useCategories(locationId, user);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const shouldHaveClass = scrollPosition > 20;
    setCategoryScrolled(shouldHaveClass);
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const encodedData = urlParams.get('data');

  //     // Decode and parse the data back into an object
  const location = JSON.parse(decodeURIComponent(encodedData));

  useEffect(() => {
    if (location) {
      if (!location.is_live) {
        handleIsLiveLocationRedirection('', location, isItMobile);
      } else {
        dispatch(setLocation(location));
        dispatch(updateIsOrderTypeSelected(true));
        dispatch(updateOrderType(CONSTANT.PICK_UP_ORDER_TYPE));
        dispatch(updateOrderDetails(null));
        refetchMenu();
      }
    }
  }, [location]);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const clearSearch = (): void => {
    setSearchText('');
    setIsSearching(false);
    setItems([]);
  };
  useEffect(() => {
    if (!isFetching) {
      setLoading(false);
    }
  }, [isFetching]);
  const searchHide = (): void => {
    setSearchShow(false);
    if (!searchText) return;
    getSearchItems();
    setIsSearching(true);
  };

  const getSearchItems = (): void => {
    const searchArray = [];
    for (let i = 0; i < menus.length; i++) {
      const menuItemsToSearchFrom = menus[i].items;
      menuItemsToSearchFrom.forEach((item) => {
        if (
          item.name
            .toLocaleLowerCase()
            .includes(searchText.toLocaleLowerCase()) ||
          item.description
            .toLocaleLowerCase()
            .includes(searchText.toLocaleLowerCase())
        ) {
          searchArray.push(item);
        }
      });
    }
    setItems(searchArray);
  };

  const [accountStatusModal, setAccountStatusModal] = useState<IAccountStatus>({
    code: null,
    buttonText: null,
    isError: null,
    header: null,
    text: null,
    email: null,
    show: false,
  });
  const { isVerifyingEmailLink } = useVerifyAccount(
    accountStatusModal,
    setAccountStatusModal,
  );
  const closeAccountStatusModal = () => {
    setAccountStatusModal({
      code: null,
      buttonText: null,
      isError: null,
      header: null,
      text: null,
      email: null,
      show: false,
    });
  };
  const updateAccountStatusModal = (
    header: string,
    text: string,
    code: number,
    buttonText: string,
    email: string,
    isError: boolean,
  ) => {
    setAccountStatusModal({
      code,
      buttonText,
      isError,
      header,
      text,
      email,
      show: true,
    });
  };
  useEffect(() => {
    if (!categoryMenuVisbility) setCategoryMenuVisbility(true);
    if (menus.length > 0) {
      if (
        selected_category &&
        menus.some((menu) => menu.name === selected_category)
      ) {
        setKey(selected_category);
      } else {
        if (menus.length >= 1) setKey(menus[0].name);
        else setKey(menus[0].name);
      }
    }
  }, [menus, selected_category]);

  useEffect(() => {
    if (key) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      history.push(`${CONSTANT.ROUTE_MENU}/${key}`);
    }
  }, [key]);

  return (
    <>
      {loading || isFetching ? (
        <Loader modalSpinner={true} />
      ) : (
        <div
          className={`${styles.menu_items_wrapper} ${
            isLiveOrderBarShow !== null && styles.liveOrderBarShowMenu
          }`}
        >
          <Container fluid>
            <Row>
              <Col>
                <div className={styles.tabsSearchWrap}>
                  <ItemSearch
                    targetState={searchText}
                    setTargetState={setSearchText}
                    searchHandle={searchHide}
                    clearSearch={clearSearch}
                    SearchShow={SearchShow}
                    // getSearchResults={getSearchResults}
                  />
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey={menus.length > 0 && menus[0].name}
                    activeKey={key}
                  >
                    <Nav
                      variant="pills"
                      className={`${
                        categoryScrolled ? styles.scroll_shadow_nav : ''
                      }`}
                    >
                      <NavItems
                        menus={menus}
                        clearSearch={clearSearch}
                        setIsSearching={setIsSearching}
                        isSearching={isSearching}
                      />
                      <div
                        className={styles.menuSearchIcon}
                        onClick={() => setSearchShow((prev) => !prev)}
                      >
                        <MagnifyingGlass width={29} height={29} />
                      </div>
                    </Nav>
                    <Tab.Content>
                      <NavItemContent
                        menus={menus}
                        isSearching={isSearching}
                        items={items}
                      />
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <AccountStatusModal
        accountStatusModal={accountStatusModal}
        updateAccountStatusModal={updateAccountStatusModal}
        closeModal={closeAccountStatusModal}
      />
    </>
  );
};

export default Menu;
